// extracted by mini-css-extract-plugin
export default {"text":"JackpotLayer_text__-u73D"};